import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function inquiryProcess  (token, params) {

    return Api.get(REQUEST_URLS.COMPANY_APPROVAL.INQUIRY_PROCESS, {
        params,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}
export default inquiryProcess;